import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextTwo = () => {
    return (
        <div className="App">
            <div className="App-body">
                <p>
                    Upon successfully gaining access to the laptop, you find yourself at the main screen. 
                    Your next steps involve delving into Nina’s digital life, being careful to interpret
                    everything that may hold answers to Nina's vanishing. <br/><br/>

                    You navigate to her email application, a repository of her recent communications. Exploring her 
                    inbox, you pay close attention to the emails that could reveal clues about her recent activities 
                    and associations. Each message may hold vital insights into her disappearance and the secrets she
                    uncovered.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxOne/PuzzleTwo'>Go to Puzzle Two</Button>
            </div>
        </div>
    );
  };
  
export default ContextTwo;